import { EmptyData, NavMenuError } from 'shared/ui';
import { SectionMenu } from 'shared/ui/section-menu';

import { SECTION } from 'entities/navigation';
import { useGetOwnersQuery } from 'entities/owner';
import { OWNER_ROUTES } from 'shared/consts/routes/owner';

const { label, path } = SECTION['owners'];

export function ConnectedOwnersMenu() {
  const { data, isFetching, error } = useGetOwnersQuery();

  if (data && data.statusCode !== 0) {
    return <NavMenuError text={data.statusDescription} />;
  }

  if (error) {
    return <NavMenuError />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  const items = data?.owners || [];

  return (
    <SectionMenu
      loading={isFetching}
      items={items}
      menuKey={path}
      absolutePath={OWNER_ROUTES.OWNERS}
      label={label}
    />
  );
}
